<script>
    import _ from 'lodash';
    import {store} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';

    const dispatch = createEventDispatcher();
    
    const axis = store('axis', '', false);
    const cart = store('cart-items', '', '[]');
    
    export let args;

    let list = [], quantity, kv, id, name, price;

    $: list = args.mounting && args.mounting.list && args.mounting.list.length ? args.mounting.list : [];
    $: quantity = args.mounting && args.mounting.quantity ? args.mounting.quantity : 1;
    $: kv = args.mounting && args.mounting.kv ? args.mounting.kv : 0;
    $: {
        let item;

        if (!args.changed && (item = list.find(el => el.idTovar === id))) {
            name = 'Монтаж (' + item.ind1 + ')';
            price = +(quantity * (item.opt_price * kv > item.price ? item.opt_price *kv : item.price)).toFixed(2);
        }
    }

    const change = () => {
        args.changed = true;
    };

    const add_montage = (idTovar, price, name = 'Монтаж') => {
        if ($axis) {
            let params = {
                idTovar: parseInt(idTovar),
                name: 'Монтаж',
                kolvo: 1,
                maxkolvo: 1,
                summa: parseFloat(price),
                summaRozn: parseFloat(price),
                summaDil: parseFloat(price),
                sebestoim: parseFloat(price),
            };
        
            window.top.postMessage('add_item::' + JSON.stringify(params), '*');
        } else {
            let data = ($cart || []);
        
            data.push({
                idTovar: parseInt(idTovar),
                type: 'монтаж', // fullDisplayPath
                title: 'Монтаж',
                name: name,
                subname: '',
                quantity: 1,
                price: {
                    rozn: parseFloat(price),
                    opt: parseFloat(price),
                    sebest: parseFloat(price),
                },
            });
        
            cart.save(data);
        
            let popup = new bootstrap.Modal(document.getElementById('item-add'));
            popup.show();
        
            setTimeout(() => {
                popup.hide();

                document.querySelector('[data-bs-target="#cartPanel"]').click();
            }, 1500);
        }
    };
</script>

{#if args.mounting}
    <div class="card-body">
        <div class="row">
            <label class="form-label">Стоимость монтажа</label>
            <div class="col-6 col-md-4">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <select class="form-control form-select" bind:value={id} on:change={change}>
                            {#each _.uniqBy(args.mounting.list, 'ind1') as item}
                                <option value="{item.idTovar}">{item.ind1}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-6 col-md-4">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <input type="number" class="form-control" bind:value={price} on:change={change} on:keydown={change}>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-4">
                <div class="form-group boxed">
                    <button type="button" class="btn btn-secondary btn-block" on:click={() => add_montage(id, price, name)}>
                        Добавить
                    </button>
                </div>
            </div>
        </div>
    </div>
{/if}
